export function getBoundsHeight(elements: HTMLElement[], offsetTop: number) {
  return Math.max(...elements.map(el => {
    const { top, height } = el.getBoundingClientRect()
    const marginBottom = parseFloat(window.getComputedStyle(el).marginBottom)
    return top + height + (isNaN(marginBottom) ? 0 : marginBottom)
  })) - offsetTop
}
